<template>
    <div v-loading="dataLoading">
        <div class="choose-box">
            <el-form :model="formData" ref="formData" label-position="top" size="medium">
                
                <template v-if="currentEnclosing">
                    <template v-if="currentEnclosing.childList && currentEnclosing.childList.length > 0">
                        <div v-for="(item, index) in formData.queryList" :key="index" class="query-box">
                            <el-card class="MB20">
                                <div slot="header" class="query-header">
                                    <div class="title">查询块{{ index + 1 }}</div>
                                    <div class="tool-box">
                                        <el-button type="primary" plain size="mini"
                                            @click="addParams(index)">添加查询条件</el-button>
                                        <el-button v-if="index > 0" type="danger" plain size="mini"
                                            @click="removeQuery(index)">删除查询块</el-button>
                                    </div>
                                </div>
                                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                    <tr>
                                        <td v-if="item.query.length > 1" class="isOr">
                                            <el-form-item :prop="`queryList[${index}].isOr`" label="">
                                                <el-select v-model="item.isOr" style="width: 120px;" size="medium">
                                                    <el-option :value="0" label="并且"></el-option>
                                                    <el-option :value="1" label="或者"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </td>
                                        <td class="params">
                                            <div v-for="(q, i) in item.query" :key="i" class="query-group">
                                                <div class="params-group">
                                                    <el-form-item :prop="`queryList[${index}].query[${i}].labelId`" label=""
                                                        :rules="[{ required: true, message: '请选择标签' }]">
                                                        <el-cascader v-model="q.labelId"
                                                            :options="currentEnclosing.childList"
                                                            :props="{ emitPath: false, value: 'id', label: 'name', children: 'childList' }"
                                                            placeholder="一级标签/二级标签/标签名称" filterable
                                                            :ref="`cascader_${index}_${i}`" @change="labelChange(index, i)"
                                                            style="width: 100%;">
                                                        </el-cascader>
                                                    </el-form-item>
                                                    <el-form-item :prop="`queryList[${index}].query[${i}].type`" label="">
                                                        <el-select v-model="q.type" :disabled="!q.label ? true : false" @change="typeChange(index, i)">
                                                            <el-option :value="0" label="等于"></el-option>
                                                            <el-option :value="1" label="不等于"></el-option>
                                                            <el-option :value="2" label="包含"></el-option>
                                                            <el-option :value="3" label="不包含"></el-option>
                                                            <template v-if="q.label && !q.label.labelValues && q.label.id != 25 && q.label.id != 26 && q.label.id != 27 && q.label.id != 28">
                                                                <el-option :value="4" label="大于"></el-option>
                                                                <el-option :value="5" label="大于等于"></el-option>
                                                                <el-option :value="6" label="小于"></el-option>
                                                                <el-option :value="7" label="小于等于"></el-option>
                                                            </template>
                                                        </el-select>
                                                    </el-form-item>
                                                    
                                                    <el-form-item :prop="`queryList[${index}].query[${i}].value`" label=""
                                                        :rules="[{ required: true, message: '标签值不可为空', trigger: 'change' }]" :key="q.type">
                                                        <el-select v-model="q.value" v-if="q.label && q.label.labelValues"
                                                            :multiple="q.type > 1 ? true : false" placeholder="选择标签值"
                                                            :disabled="!q.label ? true : false">
                                                            <el-option v-for="v in q.label.labelValues" :key="v.id"
                                                                :label="v.actualMeaning" :value="v.id">
                                                            </el-option>
                                                        </el-select>
                                                        <el-select
                                                            v-else-if="q.label && (q.label.id == 25 || q.label.id == 27)"
                                                            v-model="q.value" :multiple="q.type > 1 ? true : false" placeholder="选择省份" filterable>
                                                            <el-option v-for="(p, x) in province" :key="x" :value="p.id"
                                                                :label="p.name"></el-option>
                                                        </el-select>
                                                        <el-cascader
                                                            v-else-if="q.label && (q.label.id == 26 || q.label.id == 28)"
                                                            v-model="q.value" :options="cityList" filterable collapse-tags
                                                            :props="{ label: 'name', children: 'cityList', value: 'code', emitPath: false, multiple: q.type > 1 ? true : false }"
                                                            style="width:100%" ref="cityCascader">
                                                        </el-cascader>
                                                        <el-input v-else v-model="q.value" placeholder="输入标签值，多个标签用逗号分隔"
                                                            :disabled="!q.label ? true : false"></el-input>
                                                    </el-form-item>

                                                </div>
                                                <div class="handle">
                                                    <el-button v-if="i > 0" size="medium"
                                                        @click="removeParams(index, i)">删除</el-button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </el-card>
                            <el-divider v-if="index < formData.queryList.length - 1">并且</el-divider>
                        </div>
                        <div class="btn-box">
                            <el-button plain @click="addQuery" icon="el-icon-plus" class="add-query-btn" size="mini">添加查询块</el-button>
                            <div class="btns MT30">
                                <el-button type="primary" icon="el-icon-search" @click="query" size="mini"
                                    :loading="btnLoading">查询</el-button>
                                <el-button icon="el-icon-refresh-left" @click="clearQuery" size="mini">重置</el-button>
                            </div>
                        </div>
                    </template>
                    <el-card v-else>
                        暂无可查询条件
                    </el-card>
                </template>
            </el-form>
        </div>
    </div>
</template>

<script>
import { fetchProvince, fetchAllCity } from '@/assets/js/commonApi'

const _defaultQuery = {
    labelId: "",
    type: 0,
    value: "",
    label: null
}
const _defaultQueryGroup = {
    isOr: 0,
    query: [{
        ..._defaultQuery
    }]
}
export default {
	props: {
	    circleParam:{
	        type: Object,
	        default: null,
	    },
		circleNum:{
			type: [Number,String],
			default: ""
		}
	},
    data() {
        return {
            data: null,
            dataLoading: false,
            formData: {
                type: "",
                queryList: []
            },
            currentEnclosing: null,
            queryData: null,
            btnLoading: false,
            notify: null,
            province: [],
            cityList: []
        }
    },
    watch: {
        'formData.type': {
            handler(val) {
                this.currentEnclosing = this.data.find(item => item.id == val)
                this.reset()
            },
            deep: true
        }
    },
    created() {
        this.addQuery()
        this.getData()
        this.getProvince()
        this.getCityList()
    },
    methods: {
        //获取基础数据
        getData() {
            this.dataLoading = true
            this.$request({
                url: "/label/chooseBox",
                method: "POST",
                data: {},
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.formData.type = this.data.length > 0 ? this.data[0].id : ""
                    } else {
                        this.data = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //获取所有省份
        async getProvince() {
            const res = await fetchProvince({}).catch(() => { });
            const { state, result } = res.data;
            if (state == 1) {
                this.province = result;
            }
        },
        //获取所有城市
        async getCityList() {
            const res = await fetchAllCity({}).catch(() => { });
            const { state, result } = res.data;
            if (state == 1) {
                this.cityList = result;
            }
        },
        //添加查询块
        addQuery() {
            this.formData.queryList.push({
                ..._defaultQueryGroup,
                query: [{
                    ..._defaultQuery
                }]
            })
        },
        // 删除查询块
        removeQuery(index) {
            this.formData.queryList.splice(index, 1)
        },
        // 添加查询条件
        addParams(index) {
            this.formData.queryList[index].query.push({
                ..._defaultQuery
            })
        },
        //删除查询条件
        removeParams(index, i) {
            this.formData.queryList[index].query.splice(i, 1)
        },
        //选择标签
        labelChange(index, i) {
            this.$nextTick(() => {
                this.formData.queryList[index].query[i].label = (this.$refs[`cascader_${index}_${i}`][0]).getCheckedNodes()[0].data
                this.formData.queryList[index].query[i].type = 0;
                this.formData.queryList[index].query[i].value = "";
            })
        },
        //选择类型
        typeChange(index, i) {
            // this.$nextTick(() => {
                if( this.formData.queryList[index].query[i].type > 1 && this.formData.queryList[index].query[i].label && this.formData.queryList[index].query[i].label.labelValues){
                    this.formData.queryList[index].query[i].value = [];
                }else{
                    this.formData.queryList[index].query[i].value = "";
                }
                // this.$forceUpdate()
            // })
        },
        //查询
        query() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {

                    let _queryData = {
                        // type: this.formData.type,
                        queryList: JSON.parse(JSON.stringify(this.formData.queryList))
                    }
                    _queryData.queryList.forEach(item => {
                        item.query.forEach(query => {
                            delete query.label;
                            query.value = query.value.toString();
                            query.value = query.value.replaceAll("，", ",");
                        })
                    })
                    this.queryData = _queryData;

                    this.btnLoading = true;
                    this.$request({
                        url: '/label/circle',
                        data: { ...this.queryData },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
								
								this.$emit('update:circleNum',result)
                                if (result > 1000000) {
                                    this.$message.error('最多只能发送100W用户，请重新选择！');
									this.$emit('update:circleNum',0)									
                                }
								if( result > 0 && result <= 1000000){
									this.$emit('update:circleParam',this.queryData)
									this.$emit('update:circleNum',result)
								}
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error(msg || "操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            })
        },
       
		//重置
        reset() {
            this.formData.queryList = [{ ..._defaultQueryGroup, query: [{ ..._defaultQuery }] }]
        },
        //清除
        clearQuery() {
            this.$confirm('是否重置所有查询条件？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.reset();
            }).catch(() => { });
        }
    }

}
</script>

<style lang="scss" scoped>
.query-group {
    display: flex;

    .params-group {
        display: flex;
        flex: 1;
        position: relative;

        &::after {
            content: "";
            position: absolute;
            top: 18px;
            left: -19px;
            width: 20px;
            height: 1px;
            background: #e6e6e6;
        }

        .el-form-item {

            &:first-child,
            &:last-child {
                flex: 1;
            }

            &:nth-child(2) {
                width: 125px;
                margin: 0 10px;
            }
        }
    }

    .handle {
        margin-left: 20px;
        width: 70px;
    }
}


.add-query-btn {
    width: 100%;
    // border-style: dashed;
}

.query-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

table {
    // border-top: 1px #eee solid;
    // border-bottom: 1px #eee solid;

    td {
        padding-top: 22px;

        &.isOr {
            width: 140px;
            border-right: 1px #eee solid;

            .el-form-item {
                position: relative;

                &::after {
                    content: "";
                    position: absolute;
                    top: 18px;
                    right: -1px;
                    width: 16px;
                    height: 1px;
                    background: #e6e6e6;
                }
            }
        }

        &.params {
            padding-left: 20px;
        }
    }
}
</style>